import React from 'react';
import { Tabs, Tab } from '@mui/material';
import { styled } from '@mui/styles';

const AntTabs = styled((props) => <Tabs disableRipple {...props} />)(
  ({ theme }) => ({
    minWidth: 0,
    minHeight: theme.spacing(3),
    border: `1px solid ${theme.palette.secondary.main}`,
    borderRadius: theme.shape.borderRadius,
    marginBottom: theme.spacing(1),
  }),
);
const AntTab = styled((props) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    minWidth: 0,
    minHeight: theme.spacing(3),
    padding: 0,
    fontWeight: theme.typography.fontWeightRegular,
    color: theme.palette.secondary.main,
    '&:hover': {
      backgroundColor: theme.palette.secondary.light,
      color: theme.palette.secondary.contrastText,
      opacity: 1,
    },
    '&.Mui-selected': {
      color: theme.palette.secondary.contrastText,
      backgroundColor: theme.palette.secondary.main,
      fontWeight: theme.typography.fontWeightMedium,
    },
    '&.Mui-focusVisible': {
      backgroundColor: theme.palette.secondary.dark,
    },
  }),
);

const PieTabs = ({ value, onChange }) => {
  return (
    <AntTabs
      {...{
        value,
        onChange,
        variant: 'fullWidth',
        indicatorColor: 'secondary',
      }}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <AntTab label="주간" />
      <AntTab label="월간" />
    </AntTabs>
  );
};

export default PieTabs;
